// Generated by apps/backend/scripts/sync-toast-menu-images-to-r2.mjs on 2026-10-29
// from the Toast menu published 2026-10-29T15:56:22.625+0000. Do not edit by hand; rerun the
// script (see its header).
//
// Each photo is a square crop of the full-resolution original Toast stores for
// the item, encoded at several widths. Pass `srcSet` with a `sizes` that
// matches the rendered width so the browser picks a sharp file for the
// screen's pixel density. `width`/`height` are the largest file's size.
//
// The table stores only each photo's file stem and largest width; the URLs are
// built on demand. Spelled out, 90 photos x 6 URLs was ~60 KB of JavaScript.

export type ToastMenuImage = {
  src: string
  srcSet: string
  width: number
  height: number
}

const BASE_URL = "https://pub-32df7c4bc29843a79abbd70027a66e60.r2.dev/toast-menu/2026-10-29"
const VARIANT_WIDTHS = [320, 480, 640, 960, 1280]
const DEFAULT_SRC_WIDTH = 640

// [file stem, largest width]. Files exist at <stem>-<width>.webp for every
// VARIANT_WIDTHS entry below the largest width, plus the largest itself.
const PHOTOS = {
  "Mexican Sidecar": ["mexican-sidecar-ded587e1", 1280],
  "Longanisa Rice Bowl": ["longanisa-rice-bowl-14afe271", 1122],
  "Breakfast BurriTUS": ["breakfast-burritus-87d3d5a7", 1280],
  "Avocado Bacon Toast": ["avocado-bacon-toast-1010c666", 1280],
  "Belly 2 Belly Rice Bowl": ["belly-2-belly-rice-bowl-b41844f3", 1280],
  "Belly On Fire Rice Bowl": ["belly-on-fire-rice-bowl-2f0df40f", 1280],
  "Breakfast Sandwich": ["breakfast-sandwich-f391408b", 1280],
  "Hot Chick Rice Bowl": ["hot-chick-rice-bowl-c0e69c28", 1280],
  "RenDaang Beef Curry Bowl": ["rendaang-beef-curry-bowl-cc772bc8", 1280],
  "Spam Rice Bowl": ["spam-rice-bowl-35c78600", 1280],
  "Sweet Chick Rice Bowl": ["sweet-chick-rice-bowl-607817a1", 1280],
  "Take Ur Seat Salad": ["take-ur-seat-salad-fbd7d86b", 1280],
  "Tofu Mushroom Bowl": ["tofu-mushroom-bowl-48b99959", 1280],
  "Spam Musubi": ["spam-musubi-aa2883c7", 1094],
  "TUS Style Fries": ["tus-style-fries-6cd42264", 1158],
  "TUS Style Musubi": ["tus-style-musubi-ae6811bb", 1280],
  "Twisties Fries": ["twisties-fries-807630b7", 1280],
  "Fries": ["fries-0d82f985", 1280],
  "Side Avocado (1/2)": ["side-avocado-1-2-d5200cd4", 1280],
  "Side Cucumber Tomato Salad (4oz)": ["side-cucumber-tomato-salad-4oz-b34affd0", 450],
  "Side Eggs (2)": ["side-eggs-2-d7f3fd34", 1280],
  "Side Multigrain Toast (1)": ["side-multigrain-toast-1-80ca9512", 1280],
  "Side Spam (2)": ["side-spam-2-ff0d9ee8", 1280],
  "Side White Rice": ["side-white-rice-6f16b2f2", 1280],
  "Double Ube Salt Bread": ["double-ube-salt-bread-717ba048", 720],
  "Pandan Kaya Salt Bread": ["pandan-kaya-salt-bread-058485b6", 720],
  "Butter Salt Bread": ["butter-salt-bread-06adc1f6", 720],
  "Garlic Cream Cheese Salt Bread": ["garlic-cream-cheese-salt-bread-5b5bc70f", 720],
  "Japanese Sausage Salt Bread": ["japanese-sausage-salt-bread-8a17d68b", 720],
  "Beef Salt Bread": ["beef-salt-bread-c196e679", 1280],
  "Mini Chocolate Chip Cookies": ["mini-chocolate-chip-cookies-c3cb7922", 604],
  "Best Chocolate Chip Cookies": ["best-chocolate-chip-cookies-bb7288e8", 1280],
  "Pandan Biscoff Snickerdoodle": ["pandan-biscoff-snickerdoodle-a32b69a2", 606],
  "Sea Salt Walnut Cookies": ["sea-salt-walnut-cookies-bd6d1ba5", 606],
  "S'mores Cookies": ["s-mores-cookies-5bf082f7", 604],
  "Pumpkin Cream Cheese Muffin": ["pumpkin-cream-cheese-muffin-cc163e9b", 1280],
  "Banana Chocolate Chip Muffin": ["banana-chocolate-chip-muffin-dd3e4f27", 1280],
  "Longanisa Roll (3)": ["longanisa-roll-3-4f35710c", 752],
  "Egg-Cellent Sando": ["egg-cellent-sando-00b27c8f", 1254],
  "Salted Butter Bread – 2 for $5.50": ["salted-butter-bread-2-for-5-50-0e6cf877", 1280],
  "Salted Butter Beef Bread – 2 for $7.50": ["salted-butter-beef-bread-2-for-7-50-cf6cf4b1", 1280],
  "That OatLyfe": ["that-oatlyfe-805cd699", 1280],
  "Berry Chia Pudding": ["berry-chia-pudding-c9093bf6", 994],
  "Ube Arroz con Leche": ["ube-arroz-con-leche-20d48edd", 1024],
  "Arroz con Leche": ["arroz-con-leche-c7d0233a", 1024],
  "Tiramisu Cup": ["tiramisu-cup-efb6654a", 1280],
  "Belibis Hot Sauce Pouch": ["belibis-hot-sauce-pouch-be3918f2", 1280],
  "Belibis Hot Sauce Bottle": ["belibis-hot-sauce-bottle-8b21eb92", 1280],
  "Longanisa Roll (1 dzn)": ["longanisa-roll-1-dzn-623bead3", 606],
  "Babyccino": ["babyccino-d8379487", 1280],
  "Chagaccino": ["chagaccino-a7594406", 1280],
  "Cookie Butter Latte": ["cookie-butter-latte-806af58b", 1280],
  "Ghirardelli Hot Cocoa": ["ghirardelli-hot-cocoa-150cfe22", 1280],
  "Houjicha Latte": ["houjicha-latte-5827be12", 1280],
  "Melon Latte + Foam": ["melon-latte-foam-fd5074c4", 1280],
  "Milo Dinosaur": ["milo-dinosaur-fdeeddbd", 1280],
  "Monk Fruit Vanilla Latte (sugar free)": ["monk-fruit-vanilla-latte-sugar-free-0e1afc78", 1280],
  "Pandan Latte": ["pandan-latte-1c9016cd", 1280],
  "Spanish Latte": ["spanish-latte-35ad9861", 1280],
  "Sweet Latte": ["sweet-latte-f126aa0f", 1280],
  "Vanilla Latte": ["vanilla-latte-452cf0a2", 1280],
  "Choco Chip Latte": ["choco-chip-latte-94f765b8", 1280],
  "Banana Latte": ["banana-latte-da0ef7c7", 1280],
  "Pumpkin Spice Latte": ["pumpkin-spice-latte-fcea0c04", 1280],
  "Matcha Latte": ["matcha-latte-146b3ace", 1280],
  "Blueberry Matcha": ["blueberry-matcha-b7297885", 1280],
  "Matchanana Latte": ["matchanana-latte-f8d2d0dc", 1280],
  "Strawberry Matcha Latte": ["strawberry-matcha-latte-3af2281c", 1280],
  "Americano": ["americano-1acefea7", 1024],
  "Cappuccino": ["cappuccino-f06ad8b3", 1024],
  "Cold Brew": ["cold-brew-b41ef0fd", 1024],
  "Cortado": ["cortado-3919b777", 1024],
  "Drip Coffee": ["drip-coffee-8858fb24", 1024],
  "Espresso": ["espresso-1e8077b5", 1024],
  "Espresso Tonic": ["espresso-tonic-cc78c505", 1280],
  "Latte": ["latte-526c73de", 1024],
  "Bottled Drinks": ["bottled-drinks-b029db2d", 1280],
  "Fresh Squeezed Orange Juice": ["fresh-squeezed-orange-juice-cc4efae3", 1024],
  "Hot Tea by Republic of Tea": ["hot-tea-by-republic-of-tea-2f6fa636", 1280],
  "Iced Pandan Jasmine Sweetea": ["iced-pandan-jasmine-sweetea-121dfcf3", 1024],
  "Iced Pandan Jasmine Milk Tea": ["iced-pandan-jasmine-milk-tea-ca70b3c6", 1024],
  "Honey Citron Ginger Tea": ["honey-citron-ginger-tea-c1587b89", 1024],
  "Harmless Coconut Water": ["harmless-coconut-water-1626f62c", 1024],
  "Strawberry Milk": ["strawberry-milk-5cc36be7", 1024],
  "Ethiopia": ["ethiopia-c0df71e9", 1156],
  "Colombia": ["colombia-4a40c1f3", 792],
} as const satisfies Record<string, readonly [string, number]>

export type ToastMenuImageName = keyof typeof PHOTOS

export function toastMenuImageNames(): ToastMenuImageName[] {
  return Object.keys(PHOTOS) as ToastMenuImageName[]
}

export function getToastMenuImage(itemName: string): ToastMenuImage | undefined {
  const photo = (PHOTOS as Record<string, readonly [string, number]>)[itemName]
  if (!photo) return undefined

  const [stem, largest] = photo
  const widths = [...VARIANT_WIDTHS.filter((width) => width < largest), largest]
  const url = (width: number) => `${BASE_URL}/${stem}-${width}.webp`
  const srcWidth = widths.filter((width) => width <= DEFAULT_SRC_WIDTH).at(-1) ?? widths[0]

  return {
    src: url(srcWidth),
    srcSet: widths.map((width) => `${url(width)} ${width}w`).join(", "),
    width: largest,
    height: largest,
  }
}

export function getToastMenuImageUrl(itemName: string): string | undefined {
  return getToastMenuImage(itemName)?.src
}
